import { CompetitorsColumns } from './types';

export const mainTableRequiredColumns = [
  CompetitorsColumns.SELECTION,
  CompetitorsColumns.INDEX,
  CompetitorsColumns.NAME,
  CompetitorsColumns.RANK,
  CompetitorsColumns.SINGLES_WTN,
  CompetitorsColumns.DOUBLES_WTN,
  CompetitorsColumns.NTRP,
  CompetitorsColumns.PT_ORANGE_PLAY,
  CompetitorsColumns.PT_GREEN_WIN,
  CompetitorsColumns.PT_GREEN_PLAY,
  CompetitorsColumns.SEED,
  CompetitorsColumns.DISTRICT,
  CompetitorsColumns.SECTION,
  CompetitorsColumns.PLAYER_STATUS,
  CompetitorsColumns.OPTIONS,
];

export const selectParticipantRequiredColumns = [
  CompetitorsColumns.SELECTION,
  CompetitorsColumns.INDEX,
  CompetitorsColumns.NAME,
  CompetitorsColumns.RANK,
  CompetitorsColumns.SINGLES_WTN,
  CompetitorsColumns.DOUBLES_WTN,
  CompetitorsColumns.NTRP,
  CompetitorsColumns.PT_ORANGE_PLAY,
  CompetitorsColumns.PT_GREEN_WIN,
  CompetitorsColumns.PT_GREEN_PLAY,
  CompetitorsColumns.DISTRICT,
  CompetitorsColumns.SECTION,
  CompetitorsColumns.DRAWS,
  CompetitorsColumns.SEED,
  CompetitorsColumns.PLAYER_STATUS,
  CompetitorsColumns.OPTIONS,
];

export const qualifyingRequiredColumns = [
  CompetitorsColumns.SELECTION,
  CompetitorsColumns.INDEX,
  CompetitorsColumns.NAME,
  CompetitorsColumns.RANK,
  CompetitorsColumns.SINGLES_WTN,
  CompetitorsColumns.DOUBLES_WTN,
  CompetitorsColumns.NTRP,
  CompetitorsColumns.PT_ORANGE_PLAY,
  CompetitorsColumns.PT_GREEN_WIN,
  CompetitorsColumns.PT_GREEN_PLAY,
  CompetitorsColumns.DISTRICT,
  CompetitorsColumns.SECTION,
  CompetitorsColumns.DRAWS,
  CompetitorsColumns.SEED,
  CompetitorsColumns.PLAYER_STATUS,
  CompetitorsColumns.OPTIONS,
];

export const qualifyingRequiredTeamColumns = [
  CompetitorsColumns.SELECTION,
  CompetitorsColumns.INDEX,
  CompetitorsColumns.NAME,
  CompetitorsColumns.PLAYERS,
  CompetitorsColumns.RANK,
  CompetitorsColumns.SINGLES_WTN,
  CompetitorsColumns.DOUBLES_WTN,
  CompetitorsColumns.NTRP,
  CompetitorsColumns.PT_ORANGE_PLAY,
  CompetitorsColumns.PT_GREEN_WIN,
  CompetitorsColumns.PT_GREEN_PLAY,
  CompetitorsColumns.SEED,
  CompetitorsColumns.PLAYER_STATUS,
  CompetitorsColumns.OPTIONS,
];

export const selectTeamRequiredColumns = [
  CompetitorsColumns.SELECTION,
  CompetitorsColumns.INDEX,
  CompetitorsColumns.NAME,
  CompetitorsColumns.PLAYERS,
  CompetitorsColumns.RANK,
  CompetitorsColumns.SINGLES_WTN,
  CompetitorsColumns.DOUBLES_WTN,
  CompetitorsColumns.NTRP,
  CompetitorsColumns.PT_ORANGE_PLAY,
  CompetitorsColumns.PT_GREEN_WIN,
  CompetitorsColumns.PT_GREEN_PLAY,
  CompetitorsColumns.SEED,
  CompetitorsColumns.PLAYER_STATUS,
  CompetitorsColumns.OPTIONS,
];

export const availablePlayersTeamRequiredColumns = [
  CompetitorsColumns.SELECTION,
  CompetitorsColumns.INDEX,
  CompetitorsColumns.NAME,
  CompetitorsColumns.RANK,
  CompetitorsColumns.SINGLES_WTN,
  CompetitorsColumns.DOUBLES_WTN,
  CompetitorsColumns.NTRP,
  CompetitorsColumns.PT_ORANGE_PLAY,
  CompetitorsColumns.PT_GREEN_WIN,
  CompetitorsColumns.PT_GREEN_PLAY,
  CompetitorsColumns.OPTIONS,
];

export const alternateTableRequiredColumns = [
  CompetitorsColumns.SELECTION,
  CompetitorsColumns.INDEX,
  CompetitorsColumns.NAME,
  CompetitorsColumns.RANK,
  CompetitorsColumns.SINGLES_WTN,
  CompetitorsColumns.DOUBLES_WTN,
  CompetitorsColumns.NTRP,
  CompetitorsColumns.PT_ORANGE_PLAY,
  CompetitorsColumns.PT_GREEN_WIN,
  CompetitorsColumns.PT_GREEN_PLAY,
  CompetitorsColumns.OPTIONS,
];

export const alternateTeamsRequiredColumns = [
  CompetitorsColumns.SELECTION,
  CompetitorsColumns.INDEX,
  CompetitorsColumns.NAME,
  CompetitorsColumns.PLAYERS,
  CompetitorsColumns.RANK,
  CompetitorsColumns.SINGLES_WTN,
  CompetitorsColumns.DOUBLES_WTN,
  CompetitorsColumns.NTRP,
  CompetitorsColumns.PT_ORANGE_PLAY,
  CompetitorsColumns.PT_GREEN_WIN,
  CompetitorsColumns.PT_GREEN_PLAY,
  CompetitorsColumns.SEED,
  CompetitorsColumns.OPTIONS,
];

export const alternatePlayersTeamRequiredColumns = [
  CompetitorsColumns.SELECTION,
  CompetitorsColumns.INDEX,
  CompetitorsColumns.NAME,
  CompetitorsColumns.RANK,
  CompetitorsColumns.SINGLES_WTN,
  CompetitorsColumns.DOUBLES_WTN,
  CompetitorsColumns.NTRP,
  CompetitorsColumns.PT_ORANGE_PLAY,
  CompetitorsColumns.PT_GREEN_WIN,
  CompetitorsColumns.PT_GREEN_PLAY,
  CompetitorsColumns.OPTIONS,
];

export const unpairedTableRequiredColumns = [
  CompetitorsColumns.SELECTION,
  CompetitorsColumns.INDEX,
  CompetitorsColumns.NAME,
  CompetitorsColumns.RANK,
  CompetitorsColumns.DOUBLES_WTN,
  CompetitorsColumns.SINGLES_WTN,
  CompetitorsColumns.NTRP,
  CompetitorsColumns.PT_ORANGE_PLAY,
  CompetitorsColumns.PT_GREEN_WIN,
  CompetitorsColumns.PT_GREEN_PLAY,
  CompetitorsColumns.DISTRICT,
  CompetitorsColumns.SECTION,
  CompetitorsColumns.OPTIONS,
];

export const withdrawnTableRequiredColumns = [
  CompetitorsColumns.SELECTION,
  CompetitorsColumns.INDEX,
  CompetitorsColumns.NAME,
  CompetitorsColumns.RANK,
  CompetitorsColumns.SINGLES_WTN,
  CompetitorsColumns.DOUBLES_WTN,
  CompetitorsColumns.NTRP,
  CompetitorsColumns.PT_ORANGE_PLAY,
  CompetitorsColumns.PT_GREEN_WIN,
  CompetitorsColumns.PT_GREEN_PLAY,
  CompetitorsColumns.OPTIONS,
];

export const withdrawnTeamTableRequiredColumns = [
  CompetitorsColumns.SELECTION,
  CompetitorsColumns.NAME,
  CompetitorsColumns.PLAYERS,
  CompetitorsColumns.RANK,
  CompetitorsColumns.SINGLES_WTN,
  CompetitorsColumns.DOUBLES_WTN,
  CompetitorsColumns.NTRP,
  CompetitorsColumns.PT_ORANGE_PLAY,
  CompetitorsColumns.PT_GREEN_WIN,
  CompetitorsColumns.PT_GREEN_PLAY,
  CompetitorsColumns.OPTIONS,
];

export const withdrawnPlayersTeamTableRequiredColumns = [
  CompetitorsColumns.SELECTION,
  CompetitorsColumns.NAME,
  CompetitorsColumns.RANK,
  CompetitorsColumns.SINGLES_WTN,
  CompetitorsColumns.DOUBLES_WTN,
  CompetitorsColumns.NTRP,
  CompetitorsColumns.PT_ORANGE_PLAY,
  CompetitorsColumns.PT_GREEN_WIN,
  CompetitorsColumns.PT_GREEN_PLAY,
  CompetitorsColumns.OPTIONS,
];
